const ROUTE_LABELS = {
  dashboard: 'Dashboard',
  clients: 'Clients',
  'pending-work': 'Pending Work',
  checkpoints: 'Agency checkpoints',
  'client-onboarding': 'Client Onboarding',
  'my-queue': 'My Queue',
  practices: 'Practice',
  locations: 'Location',
  reports: 'Reports',
  kanban: 'Kanban',
  'my-activity': 'My Activity',
  tasks: 'Task List',
  tools: 'Tools',
  'tool-catalog': 'Tool catalog',
  people: 'People',
  settings: 'Settings',
  security: 'Security',
  notifications: 'Notifications',
  inbox: 'Notifications',
  'client-mail': 'Client mail',
  mailbox: 'Mailbox',
  drafts: 'My drafts',
  'api-keys': 'API Keys',
  'prompt-templates': 'Prompt Templates',
  'notification-rules': 'Notification Rules',
  'auto-generation': 'Automated Generation',
  'skill-context': 'Skill Context',
  support: 'Support',
  documents: 'Documents',
  live: 'Live',
  queries: 'Queries',
  stages: 'Stages',
  content: 'Content Studio',
  'my-team': 'My Team',
  review: 'Review',
  'report-card': 'Report Card',
};

export function buildBreadcrumbs(pathname, dynamic = {}) {
  const segments = pathname.split('/').filter(Boolean);
  if (!segments.length) return [];

  const crumbs = [];
  let path = '';

  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i];
    path += `/${seg}`;

    // Skip dynamic IDs — use dynamic label if provided
    if (seg.match(/^[a-f0-9]{24}$/i)) {
      const key = segments[i - 1];
      const label = dynamic[key] || dynamic.id || 'Details';
      crumbs.push({ label, href: i < segments.length - 1 ? path : undefined });
      continue;
    }

    const label = ROUTE_LABELS[seg] || seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    crumbs.push({ label, href: i < segments.length - 1 ? path : undefined });
  }

  return crumbs;
}
